<template>
  <yxt-drawer
    size="960px"
    :append-to-body="true"
    :title="$t('biz_te_choose_teach'/*选择讲师*/)"
    :visible.sync="visible"
    destroy-on-close
    :before-close="hasChange"
    @closed="closed">
    <yxtbiz-teacher-selector
      v-model="users"
      :allowSelectUser='allowSelectUser'
      :singleMode="singleMode"
      :type="teacherType"
      :newReq="newReq"
      :prepared="prepared"
      @select="selectUser" />
    <div slot="footer">
      <yxt-button
        plain
        @click="closed">
        {{ $t('pc_comp_drawer_cancel'/* 取消 */) }}
      </yxt-button>
      <yxt-button
        type="primary"
        @click="save">
        {{ $t('pc_comp_drawer_confirm'/* 确定 */) }}
      </yxt-button>
    </div>
  </yxt-drawer>
</template>

<script>

export default {
  props: {
    // 选择的讲师
    value: {
      type: [Array, Object],
      default: () => []
    },
    // 讲师抽屉是否可见
    visible: {
      type: Boolean,
      default: false
    },
    // 讲师类型
    teacherType: {
      type: Number,
      default: -1
    },
    // 是否单选模式
    singleMode: {
      type: Boolean,
      default: false
    },
    // 是否允许选择其它人员
    allowSelectUser: {
      type: Boolean,
      default: true
    },
    // 是否切换到新组件模式 0-否 1-是
    newReq: {
      type: Boolean,
      default: false
    },
    // 是否显示候补讲师(默认不显示预备) 0-否 1-是
    prepared: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      users: []
    };
  },
  watch: {
    visible(val) {
      // if (this.singleMode) {

      // }
      val && (this.users = this.value);
    }
  },
  methods: {
    // 二次确认
    hasChange(done) {
      if ((!this.singleMode && (this.users.length !== this.value.length ||
        this.users.some(arg1 => {
          return !this.value.some(arg2 => arg1.id === arg2.id);
        }))) ||
        (this.singleMode && this.value.id !== this.users.id)
      ) {
        this.$confirm(this.$t('pc_comp_drawer_confirmCancel'), this.$t('pc_comp_drawer_msgCancel'), {
          confirmButtonText: this.$t('pc_comp_drawer_confirm'),
          cancelButtonText: this.$t('pc_comp_drawer_cancel'),
          type: 'warning'
        }).then(() => {
          this.save();
          done();
        }).catch(() => { });
      } else {
        done();
      }
    },
    // 关闭
    closed() {
      this.$emit('update:visible', false);
    },
    // 保存
    save() {
      this.$emit('submit', this.users);
      this.closed();
    },
    // 选择讲师
    selectUser(user) {
      // this.$emit('select', user)
    }
  }
};
</script>
